/**
 * This file is auto-generated from TrustSection.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const heading: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Privacy & real clinicians';
        case 'pl':
            return 'Prywatność i prawdziwi lekarze';
    }
};

export const realCliniciansTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Real, licensed clinicians';
        case 'pl':
            return 'Prawdziwi, licencjonowani lekarze';
    }
};

export const realCliniciansDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Every case is reviewed and approved by a licensed physician.';
        case 'pl':
            return 'Każdy przypadek jest przekazywany do licencjonowanego lekarza.';
    }
};

export const gdprCompliantTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Your data is safe';
        case 'pl':
            return 'Twoje dane są bezpiecznie';
    }
};

export const gdprCompliantDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'We follow GDPR, encrypt all data in transit and at rest, and store it in the EU with carefully vetted providers.';
        case 'pl':
            return 'Przestrzegamy RODO, szyfrujemy wszystkie przesyłane i zapisane dane oraz przechowujemy je w UE u sprawdzonych dostawców.';
    }
};

export const privacyByDesignTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Privacy by design';
        case 'pl':
            return 'Pełna ochrona prywatności';
    }
};

export const privacyByDesignDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'We do not sell your data or share it with advertisers or other third parties for marketing.';
        case 'pl':
            return 'Nie sprzedajemy Twoich danych ani nie udostępniamy ich reklamodawcom lub innym podmiotom zewnętrznym w celach marketingowych.';
    }
};

export const noModelTrainingTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'No AI training on your case';
        case 'pl':
            return 'Nie trenujemy AI na Twoich danych';
    }
};

export const noModelTrainingDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'We do not use your personal health data to train AI models.';
        case 'pl':
            return 'Nie używamy Twoich danych personalnych ani medycznych do trenowania modeli AI.';
    }
};

export const physicianAccessTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Only your doctor can see the details';
        case 'pl':
            return 'Tylko Twój lekarz może zobaczyć szczegóły';
    }
};

export const physicianAccessDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Only your treating physician can access the full details of your consultation, as required by law.';
        case 'pl':
            return 'Tylko Twój lekarz prowadzący może uzyskać dostęp do pełnych szczegółów Twojej konsultacji, zgodnie z wymogami prawa.';
    }
};

export const registeredEntityTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Officially registered medical entity';
        case 'pl':
            return 'Oficjalnie zarejestrowany podmiot medyczny';
    }
};

export const registeredEntityDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'We operate as a registered and regulated medical entity (RPWDL 000000294316).';
        case 'pl':
            return 'Działamy jako zarejestrowany i regulowany podmiot medyczny (RPWDL 000000294316).';
    }
};
